var _path, _rect, _rect2, _rect3, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoFiltersResults = function SvgNoFiltersResults(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 256,
    viewBox: "0 0 130 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3447 181.036L10.6767 111.236C7.28893 105.421 11.4834 98.123 18.213 98.123L113.604 98.1231C120.333 98.1231 124.528 105.421 121.14 111.236L81.2121 179.766V202.153C81.2121 204.528 79.8571 206.694 77.7219 207.734L56.3036 218.164C54.0127 219.28 51.3447 217.611 51.3447 215.063V181.036Z",
    fill: "url(#paint0_linear_159_48489)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.8687,
    y: 50.5332,
    width: 30.3507,
    height: 22.0732,
    rx: 7.26761,
    transform: "rotate(-28.5212 70.8687 50.5332)",
    fill: "#F1F9FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5471,
    width: 45.5819,
    height: 33.1505,
    rx: 9.99296,
    transform: "rotate(39.6564 41.5471 0)",
    fill: "#F1F9FE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.3804,
    y: 60.1836,
    width: 18.591,
    height: 13.5207,
    rx: 6.76036,
    transform: "rotate(30 40.3804 60.1836)",
    fill: "#F1F9FE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65,
    cy: 249.824,
    rx: 64.5,
    ry: 5.4507,
    fill: "url(#paint1_linear_159_48489)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_159_48489",
    x1: 43.6516,
    y1: 121.733,
    x2: 122.687,
    y2: 121.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDEFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_159_48489",
    x1: 2.65,
    y1: 252.004,
    x2: 124.185,
    y2: 249.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F2FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F3FC"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoFiltersResults);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "no-filters-results.4e80ea946b1e7b1acd2c1508bda52f50.svg";